import React from "react";
import { Swiper, SwiperSlide } from "swiper/react"; // Imports the main Swiper and SwiperSlide components from Swiper's React integration.

// Import Swiper styles - these are necessary for the basic appearance of the slider.
import "swiper/css"; // Imports the core Swiper styles.
import "swiper/css/pagination"; // Imports styles specifically for the pagination (dots).
import "swiper/css/navigation"; // Imports styles specifically for the navigation buttons (arrows).

// Import Swiper modules you are using - you need to explicitly tell Swiper which features you want to use.
import { Pagination, Navigation, Autoplay } from "swiper/modules"; // Imports the specific Swiper modules for pagination, navigation, and autoplay.

function HeroSection() {
  // An array of objects that define each slide in the hero section.
  // Each object specifies the type of content ('image' or 'video'),
  // the source path ('src' - relative to the 'public' folder),
  // and any additional properties like 'alt' text for images or 'controls' for videos.
  const slides = [
    //{ type: "video", src: "/videos/hero-video.mp4", controls: true}, // First slide is a video with browser controls enabled.
    { type: "image", src: "/images/hero-image3.jpg", alt: "Featured Car 3" },
    { type: "image", src: "/images/hero-image1.jpg", alt: "Featured Car 1" }, // Subsequent slides are images with descriptive alt text for accessibility.
    { type: "image", src: "/images/hero-image2.jpg", alt: "Featured Car 2" },
  ];

  // An object containing the configuration parameters for the Swiper component.
  // These parameters control how the slider behaves and looks.
  const swiperParams = {
    modules: [Pagination, Navigation, Autoplay], // Registers the Swiper modules we imported, making their functionality available to the Swiper component.
    loop: true, // Enables infinite looping of the slides. When you reach the last slide, it will smoothly transition back to the first.
    pagination: {
      el: ".swiper-pagination", // Specifies the CSS selector for the HTML element that will be used as the container for the pagination bullets.
      clickable: true, // Makes the pagination bullets clickable, allowing users to jump directly to a specific slide.
    },
    navigation: {
      nextEl: ".swiper-button-next", // Specifies the CSS selector for the HTML element that will act as the "next" button.
      prevEl: ".swiper-button-prev", // Specifies the CSS selector for the HTML element that will act as the "previous" button.
    },
    autoplay: {
      delay: 8000, // Optional: Sets the delay (in milliseconds) between automatic slide transitions (5000ms = 5 seconds). If you don't want autoplay, you can remove this entire `autoplay` object.
      disableOnInteraction: false, // Optional: If true, autoplay will be paused when the user interacts with the slider (e.g., by dragging). Setting it to false keeps autoplaying even after user interactions.
    },
  };

  return (
    // A container div with relative positioning. This is important for positioning the navigation buttons absolutely within it.
    <div className="relative">
      {/* The main Swiper component. The {...swiperParams} syntax passes all the configurations from the swiperParams object as individual props to the Swiper component. */}
      <Swiper {...swiperParams}>
        {/* We use the .map() method to iterate over the 'slides' array and create a SwiperSlide component for each item in the array. */}
        {slides.map((slide, index) => (
          // Each SwiperSlide represents a single slide in the carousel. The 'key' prop is important for React to efficiently update the list of slides.
          <SwiperSlide key={index}>
            {/* A container div for the image or video, setting a fixed height and ensuring content doesn't overflow. */}
            <div className="relative w-full h-96 md:h-[600px] overflow-hidden">
              {/* Conditional rendering for images. If the slide object's 'type' is 'image', we display an <img> tag. */}
              {slide.type === "image" && (
                <img
                  src={slide.src} // The path to the image file (relative to the public folder).
                  alt={slide.alt} // Alternative text for the image (important for accessibility).
                  className="absolute top-0 left-0 w-full h-full object-cover" // Tailwind classes to make the image fill the container and maintain its aspect ratio.
                />
              )}
              {/* Conditional rendering for videos. If the slide object's 'type' is 'video', we display a <video> tag. */}
              {slide.type === "video" && (
                <video
                  src={slide.src}
                  controls={slide.controls} // Keep controls for user interaction
                  className="absolute top-0 left-0 w-full h-full object-cover z-10"
                  autoPlay // Add the autoplay attribute
                  muted // Add the muted attribute
                  loop // Optional: Add loop if you want the video to repeat
                />
              )}
              <div className="absolute top-0 left-0 w-full h-full bg-black opacity-50 z-10"></div>
              {/* Text overlay */}
              <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 text-center text-white z-20">
                <h1 className="font-heading text-7xl font-bold mb-2 text-white crimson-outline">
                  Moving The Chainz
                </h1>
                <p className="font-heading text-3xl text-white crimson-outline">
                  Quality Pre-Owned Vehicles and Service.
                </p>
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
      {/* The container for the pagination bullets. Swiper will automatically populate this div based on the pagination configuration in swiperParams. */}
      <div className="swiper-pagination absolute bottom-4 left-0 w-full flex justify-center z-10">
        {/* The container for the pagination bullets. Swiper will automatically populate this div based on the pagination configuration in swiperParams. */}
      </div>
      {/* The "next" navigation button. Tailwind classes are used for styling (white text, primary background, padding, rounded corners, cursor, and a higher z-index to ensure it's above the slides). Swiper will automatically attach event listeners to elements with this class to trigger the next slide. */}
      <div className="swiper-button-next absolute top-1/2 -translate-y-1/2 right-4 text-white cursor-pointer z-10"></div>
      {/* The "previous" navigation button with similar styling. Swiper will automatically attach event listeners to elements with this class to trigger the previous slide. */}
      <div className="swiper-button-prev absolute top-1/2 -translate-y-1/2 left-4 text-white cursor-pointer z-10"></div>
    </div>
  );
}

export default HeroSection;
